import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { GridCloseIcon } from '@mui/x-data-grid';
import { useAppContext } from 'core/contexts';
import styles from './SGSModal.module.scss';

import { SGSButton } from 'components';

interface ModalProps {
    isOpenModal: Boolean;
    setIsOpenModal: Function;
    title: string;
    displayCloseBtn?: boolean;
    CloseBtnText?: string;
}

const SGSModal: React.FC<ModalProps> = ({ isOpenModal, setIsOpenModal, title, children, displayCloseBtn = false, CloseBtnText = "J'ai compris" }) => {
    const { user } = useAppContext();

    const handleClose = (): void => {
        setIsOpenModal(false);
    };

    function BootstrapDialogTitle(props) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <>
                        {' '}
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            style={{
                                position: 'absolute',
                                right: 15,
                                top: 20,
                            }}
                        >
                            <GridCloseIcon
                                style={{
                                    position: 'absolute',
                                    right: 15,
                                    top: 15,
                                    color: '#FFF',
                                }}
                            />
                        </IconButton>
                    </>
                ) : null}
            </DialogTitle>
        );
    }

    return (
        <>
            <Dialog
                open={Boolean(isOpenModal && user.token)}
                onClose={handleClose}
                maxWidth="md"
                PaperProps={{
                    style: { width: '100%', maxHeight: '80vh', borderRadius: 10 },
                }}
            >
                <BootstrapDialogTitle onClose={handleClose} className={styles.header}>
                    <span className={styles.header__text}>{title}</span>
                </BootstrapDialogTitle>
                <DialogContent>
                    <DialogContentText className="m-2" style={{ minHeight: '81px', width: '98%' }}>
                        {children}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="mr-2 mb-2 mt-4 mb-4" style={{ minHeight: '59px' }}>
                    <Box className="text-center w-100">
                        {displayCloseBtn && (
                            <SGSButton onClick={handleClose} className={styles.BtnBlue}>
                                {CloseBtnText}
                            </SGSButton>
                        )}
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SGSModal;
